import React, { Component } from 'react'
import { connect } from 'react-redux'
import yup from 'yup'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import queryString from 'query-string'

import Loader from 'components/loader/loader'
import { passwordResetToken } from 'state/actions'
import SmoothCollapse from 'react-smooth-collapse'
import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

class PasswordReset extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      password: '',
      confirmPassword: '',
      isLoading: false,
      token: '',
    }
  }

  componentDidMount = _ => {
    const query = queryString.parse(this.props.location.search)
    if (query.token) {
      this.setState({
        token: query.token,
      })
    }
  }

  updateField = e => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleFormSubmit = async e => {

    e.preventDefault()

    const resetPassword = yup.object().shape({
      confirmPassword: yup
        .string()
        .oneOf([yup.ref('password'), null], `These passwords don't match.`)
        .required('Password confirm is required'),
      password: yup
        .string()
        .min(8, 'Your new password must be at least 8 characters')
        .required('Please enter a new password'),
      email: yup
        .string()
        .email()
        .required('Please enter your email'),
      token: yup.string().required("You don't have a valid reset token, please click on the link in the email")
    })

    // Validate input fields against schema
    try {
      await resetPassword.validate({ ...this.state })
    } catch (error) {
      return this.props.handleError(error.message)
    }

    this.setState({
      isLoading: true,
    })

    const { email, password, token } = this.state

    this.props.passwordResetToken({ email, password, token }, (error, response) => {
      if (error) {
        this.setState({
          isLoading: false,
        })
        return this.props.handleError(error.message)
      }

      if (response.ok) {
        this.setState({
          isLoading: false,
          email: '',
          password: '',
          confirmPassword: '',
        })
        this.props.handleSuccess('Password reset successfully.')

        setTimeout(_ => {
          this.props.history.push('/auth/login')
        },1000)
      }
    })
  }

  render() {
    const {
      validateResponse,
      handleDismiss
    } = this.props

    const {
      password,
      currentPassword,
      confirmPassword,
      isLoading
    } = this.state

    return (
      <div>
        <Loader visible={isLoading} />
        <h1>Reset your password</h1>
        <form 
          onSubmit={this.handleFormSubmit} 
          noValidate 
          className="auth-fields"
        >
          <input 
            value={currentPassword} 
            onChange={this.updateField} 
            placeholder="Email Address" 
            name="email" 
            type="email" 
          />
          <input 
            value={password} 
            onChange={this.updateField} 
            placeholder="New Password" 
            name="password" 
            type="password" 
          />
          <input
            value={confirmPassword}
            onChange={this.updateField}
            placeholder="Confirm Password"
            name="confirmPassword"
            type="password"
          />
          <SmoothCollapse expanded={!!validateResponse}>
            <ValidateResponse 
              dismissCallback={handleDismiss} 
              response={validateResponse} 
              timeout={5000} 
            />
          </SmoothCollapse>
          <button className="button huge" type="submit">
            Submit
          </button>
          <span className="auth-swap">
            Back to <Link to="/auth/login">login</Link>?
          </span>
        </form>
      </div>
    )
  }
}

const PasswordResetWithValidation = withValidateResponse(PasswordReset)
const PasswordResetWithValidationWithRouter = withRouter(PasswordResetWithValidation)

export default connect(null, { passwordResetToken })(PasswordResetWithValidationWithRouter)
